import { render, staticRenderFns } from "./UpdateContent.vue?vue&type=template&id=0adedda3"
import script from "./UpdateContent.vue?vue&type=script&lang=js"
export * from "./UpdateContent.vue?vue&type=script&lang=js"
import style0 from "./UpdateContent.vue?vue&type=style&index=0&id=0adedda3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports